/**
 * CustomsPaymentsTemplate описывает параметры шаблона таможенных платежей Альта
 */
export class CustomsPaymentsTemplate {
   /**
   * Поле, которое будет содержать общую расчитанную стоимость в рублях, для
   * всех товаров таможенных платежей с учетом таможенного сбора. Должно быть числовым.
   * При его изменении будет пересчитываться основная услуга таможенных платежей.
   */
   public TotalCostField: string = ""

   /**
   * Поле, которое будет содержать тип таможенного режима. Участвует в запросе на 
   * получение ставок. Должно быть справочником.
   */
   public CustomsModeField: string = ""

   /**
   * Поле, которое будет содержать страну. Участвует в запросе на 
   * получение ставок. Должно быть справочником.
   */
   public CountryField: string = ""

   /**
   * Поле, которое будет содержать валюту контракта. Должно быть валютой.
   */
   public ContractCurrencyField: string = ""

   /**
   * Поле, которое будет содержать сумму стоимости доставка до границы. Должно быть числом.
   */
   public BorderDeliverySumField: string = ""

   /**
   * Поле, которое будет содержать содержать валюту доставки до границы. Должно быть валютой.
   */
   public BorderDeliveryCurrencyField: string = ""

   /**
   * Поле, которое будет содержать сумму мнных расходов. Должно быть числом.
   */
   public OtherExpensesSumField: string = ""

   /**
   * Поле, которое будет содержать содержать валюту иных расходов. Должно быть валютой.
   */
   public OtherExpensesCurrencyField: string = ""

  /**
   * Заглушка для запрета прямого создания объектов данного типа
   * @private
   */
  private constructor() {
  }

  /**
   * RestoreSettings выполняет восстановление данных объекта настроек
   * Функция выполняет нормализацию значений настроек.
   * Функция дополняет недостающие настройки значениями по умолчанию.
   *
   * @param data
   */
  public static RestoreSettings(data: any): CustomsPaymentsTemplate {
    let result = new CustomsPaymentsTemplate();

    if (typeof data === "string") {
      data = JSON.parse(data)
    }

    if (typeof data !== "object") {
      return result;
    }

    Object.keys(result).map((key: keyof CustomsPaymentsTemplate) => {
      // @ts-ignore
      result[key] = CustomsPaymentsTemplate.GetCorrectFieldValue(key, data[key])
    })

    return result;
  }

  /**
   * GetCorrectFieldValue выполняет восстановление данных поля из переданного значения настроек.
   * Данный метод так же проводит валидацию значения каждой из настроек поля. Метод возвращает
   * значение по умолчанию, если значение передано не корректно.
   */
  public static GetCorrectFieldValue<T extends keyof CustomsPaymentsTemplate>(field: T, data: any): any {
    let defaults = new CustomsPaymentsTemplate()

    if (data === undefined) {
      return defaults[field]
    }

    switch (field) {
	  case "TotalCostField":
	  case "CustomsModeField":
	  case "CountryField":
	  case "ContractCurrencyField":
	  case "BorderDeliverySumField":
	  case "BorderDeliveryCurrencyField":
	  case "OtherExpensesSumField":
	  case "OtherExpensesCurrencyField":
        return typeof data === "string" ? data : defaults[field]
    }

    return defaults[field];
  }
}